import React, { useState, useRef, useEffect } from 'react'
import { useTranslation } from 'react-i18next';

const TextField = ({ placeholder, value, onChange, name, type = 'text', required, ...rest }) => {
    const { i18n } = useTranslation();
    const isArabic = i18n.language === 'ar';
    const [isFocused, setIsFocused] = useState(false);
    const [hasValue, setHasValue] = useState(false);
    const inputRef = useRef(null);

    useEffect(() => {
        setHasValue(value && value.trim() !== '');
    }, [value]);

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const isLabelActive = isFocused || hasValue;

    return (
        <div className="relative">
            <input 
                ref={inputRef}
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                required={required}
                onFocus={handleFocus}
                onBlur={handleBlur}
                className={`w-full ${isArabic ? 'text-right pr-4 pl-4' : 'px-4'} py-4 pt-6 rounded-lg ring-red-200 focus:ring-4 focus:outline-none transition-all duration-300 border border-gray-300 focus:shadow-xl peer`}
                placeholder=""
                {...rest}
            />
            <label 
                className={`absolute ${isArabic ? 'right-4' : 'left-4'} transition-all duration-300 pointer-events-none ${
                    isLabelActive 
                        ? 'top-2 text-xs text-primary font-medium transform scale-100' 
                        : 'top-4 text-sm text-gray-500 transform scale-100'
                }`}
            >
                {placeholder}
                {required && <span className={`text-red-500 ${isArabic ? 'mr-1' : 'ml-1'}`}>*</span>}
            </label>
        </div>
    )
}

export default TextField
